import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { KTCard, KTCardBody, KTSVG } from 'src/_metronic/helpers';
import { recalculateLedger } from '../_requests';
import {setMessage} from 'src/store/alertMessage/actions'
import {useDispatch, useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom'

const RecalculateForm = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const datePickerRef = useRef<any>(null);
  const dispatch = useDispatch()
  // useEffect(() => {
  //   if (datePickerRef.current?.input) {
  //     datePickerRef.current.input.focus();
  //   }
  // }, []);


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedDate) {
      setModalMessage('Please select a date before submitting.');
      setModalIsOpen(true);
      return;
    }

    setIsLoading(true);
    try {
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const year = selectedDate.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;

      const response = await recalculateLedger({ date: formattedDate });
console.log("res",response.status);
console.log(response);
console.log(response.message);


      if (response.status === 200) {
        dispatch(setMessage('success',"Date submitted successfully!"));
        // setModalMessage('Date submitted successfully!');
        // setModalIsOpen(true);
        setSelectedDate(null);
      }
    } catch (error:any) {
      dispatch(setMessage('error', error?.response.data.Error.message ?? "Script is already running. Please wait for it to finish."));
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setSelectedDate(null);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <KTCard>
      <div className='card-header'>
        <div className='card-title'>Recalculate</div>
        {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button onClick={() => navigate(-1)} className="btn btn-secondary">
                ← Back
              </button>
              </div> */}
      </div>
      <div
              className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
              style={{ zIndex: 99, top: "33px", marginLeft: "-34px" ,width: "34px",
                height: "32px"}}
              role="button"
              aria-label="Go back to previous page"
              tabIndex={0}
              data-tooltip="Back"
              onClick={() => navigate(-1)}
            >
              <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
            </div>
      <KTCardBody>
        <style>
          {`
            .form-control.date-picker:hover {
              cursor: pointer;
            }
          `}
        </style>
        <form onSubmit={handleSubmit}>
          <div className='row mb-3'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label className='d-block mb-2'>Select From Date</label>
                <DatePicker
                  ref={datePickerRef}
                  selected={selectedDate}
                  onChange={(date: Date | null) => setSelectedDate(date)}
                  className='form-control date-picker' // Added custom class
                  placeholderText='Select date'
                  dateFormat='dd-MM-yyyy'
                  onKeyDown={(event: any) => event.preventDefault()}
                  showMonthDropdown // Added for month dropdown
                  showYearDropdown // Added for year dropdown
                  dropdownMode='select'
                  disabled={isLoading}
                  maxDate={new Date()}
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 text-end'>
              <Button type='submit' className='me-3' disabled={isLoading}>
                {isLoading ? (
                  <>
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                    Loading...
                  </>
                ) : (
                  'Submit'
                )}
              </Button>
              <Button variant='secondary' type='button' onClick={handleCancel} disabled={isLoading}>
                Reset
              </Button>
            </div>
          </div>
        </form>
      </KTCardBody>
      <Modal show={modalIsOpen} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modalMessage.includes('error') ? 'Error' : 'Success'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </KTCard>
  );
};

export default RecalculateForm;